import React, {FunctionComponent, memo, useEffect, useState} from 'react';
import {useLocation} from "react-router";
import ContentWrapper from "../../reusable/layout/ContentWrapper";
import useSPTranslation from "../../reusable/useSPTranslation";
import SPLoader from "../../reusable/loader/SPLoader";

type Props = {

};

const OAuthCallback2: FunctionComponent<Props> = () => {
    const [personData, setPersonData] = useState<Record<string, string>>();
    const location = useLocation()
    const {t} = useSPTranslation();
    useEffect(() => {
        const locationState = location.state as Record<string, any>
        if (!locationState?.token) {
            return;
        }

        (async () => {
            const resp = await fetch(
                "https://europe-west3-styreportalen-development.cloudfunctions.net/api-karrierepasset/userinfo",
                {
                    method: "GET",
                    headers: {
                        authorization: `Bearer ${locationState?.token}`,
                    },
                }
            );

            if (!resp.ok) throw new Error(await resp.text());
            const result = await resp.json();
            setPersonData(result);
        })();
    }, [location])

    const construct = (value: unknown) => {
        if (Array.isArray(value)) {
            return (
                <ul style={{paddingLeft: '10px'}}>
                    {(value).map((v: any, i) => {
                        const data = construct(v);
                        return (
                            <li key={`${i}`}>
                                {data}
                            </li>
                        )
                    })}
                </ul>
            )
        }
        if (typeof value === "object") {
            return Object.entries(value || {}).map(([key, value]) => {
                const data = construct(value);
                return <div key={key} style={{paddingLeft: '10px'}}>
                    <strong>{t(`common.${key}`, key)}</strong>
                    &nbsp;
                    <span>{data}</span>
                </div>
            })
        }

        return JSON.stringify(value);
    }

    return (
        <div className="wrapper">
            <section
                className="select-section-container"
                style={{
                    marginTop: 0,
                }}
            >
                <ContentWrapper>
                    <div
                        className="card w-100"
                        style={{
                            marginTop: "45px",
                        }}
                    >
                        <div
                            className="d-flex flex-column"
                            style={{
                                padding: "1rem 2rem 1rem 2rem",
                                border: "1px solid black",
                            }}
                        >
                            {personData ? (
                                <div
                                    className="text-body text-decoration-none d-flex flex-column justify-content-center"
                                    style={{
                                        gap: '10px',
                                        margin: "1rem 0 1rem 0",
                                        letterSpacing: "0.025em",
                                        padding: "0.8rem",
                                        textTransform: "uppercase",
                                        boxShadow:
                                            "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
                                    }}
                                >
                                    {construct(personData)}
                                </div>
                            ) : (
                                <SPLoader/>
                            )}
                        </div>
                    </div>
                </ContentWrapper>
            </section>
        </div>
    );
};

export default memo(OAuthCallback2);
